import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'digi-currency-vnd',
  templateUrl: './currency-input.component.html',
  styleUrl: './currency-input.component.scss',
})
export class CurrencyInputComponent {
  // Nhận FormControl từ component cha
  @Input() control!: FormControl;

  // Placeholder tùy chỉnh
  @Input() placeholder: string = 'Nhập số tiền';

  // Hàm xử lý khi người dùng nhập dữ liệu
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ''); // Loại bỏ ký tự không phải số
    value = this.formatCurrency(value); // Format lại theo VND
    this.control.setValue(Number(value.replace(/,/g, ''))); // Cập nhật giá trị cho FormControl
    input.value = value; // Hiển thị giá trị đã format
  }

  // Hàm format tiền VND
  formatCurrency(value: string): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Thêm dấu ',' vào các nhóm 3 số
  }
}
